import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {JwtModule} from '@auth0/angular-jwt';
import {ErrorHandler, NgModule, Injectable, PLATFORM_ID} from '@angular/core';
import {NgxPermissionsModule} from 'ngx-permissions';
import {Router, RouterModule} from '@angular/router';
import {LayoutModule} from '@angular/cdk/layout';
import * as Sentry from '@sentry/angular';

// Helpers

import {AuthGuard} from './_guards/auth.guard';
import {FamilyInterceptor} from './_interceptors/family.interceptor';
import {NetworkActivityInterceptor} from './_interceptors/network-activity.interceptor';
import {environment} from '../environments/environment';
import {routing} from './app.routing';

// Services
import {AutocompleteService} from './_services/autocomplete.service';
import {AuthService} from './_services/auth.service';
import {UsersService} from './_services/users.service';

// Store

// Config
import {SignInComponent} from "./sign-in/sign-in.component";
import {ADFSCallbackComponent} from './sign-in/adfs-callback/adfs-callback.component';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import {AppsComponent} from './apps.component';
import { FamilyRoomDirectoryComponent } from "./family-room-directory/family-room-directory.component";
import { FamilyRoomDirectoryService } from "@services/family-room-directory.service";
import {
  FamilyRoomDirectoryUploadComponent
} from './family-room-directory/upload/family-room-directory-upload.component';

export function tokenGetter() {
  return localStorage.getItem('access');
}

const providers: any[] = [
  {provide: HTTP_INTERCEPTORS, useClass: FamilyInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: NetworkActivityInterceptor, multi: true},
  {provide: ErrorHandler, useValue: Sentry.createErrorHandler({showDialog: false})},
  {provide: Sentry.TraceService, deps: [Router], useValue: undefined},
];

if (environment.envName !== 'dev' && environment.envName !== 'stag') {
  // providers.push(
  //   { provide: ErrorHandler, useClass: RavenErrorHandler }
  // );
}

@NgModule({
  exports: [

  HttpClientModule,
  NgxPermissionsModule,
  ],
  imports: [
  BrowserModule, BrowserAnimationsModule, CommonModule, RouterModule,
  FormsModule, HttpClientModule, ReactiveFormsModule,
    CommonModule,
    FormsModule, ReactiveFormsModule,

    MatAutocompleteModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
  NgxPermissionsModule.forRoot(),


    JwtModule.forRoot({
    config: {
    tokenGetter: tokenGetter,
    allowedDomains: ['localhost:4200', 'localhost:8000', 'stage.bildlab.com', 'bildlab.com']
    }
    }),


  LayoutModule,

  routing,
  ],
  declarations: [
    ADFSCallbackComponent,
    FamilyRoomDirectoryComponent,
    AppsComponent,
    SignInComponent,
    FamilyRoomDirectoryUploadComponent,
  ],
  providers: [
  AuthGuard,
  AutocompleteService,
  AuthService,
  FamilyRoomDirectoryService,
  UsersService,

  providers
  ],
  bootstrap: [ AppsComponent ]
  })
export class AppsModule {
  constructor(trace: Sentry.TraceService) {}
}
